import { Box } from 'braid-design-system';

import { focusRing } from './FocusRing.css';

interface Props {
  isFocused: boolean;
  children: React.ReactNode;
}

const FocusRing: React.FC<Props> = ({ isFocused, children }) => (
  <Box className={isFocused ? focusRing : null}>{children}</Box>
);

export default FocusRing;
